<template>
      <Modal
        :id="'cmp-distribution-imports-file_uploader'"
        @cancelled="onCancel"
      >
        <template slot="header">Uploading</template>

        <template slot="body">
          <ProgressBar
            v-if="fileUploadingFlag"
            :value="fileUploaderProgress"
            :duration="fileUploaderDuration"
          />
        </template>
      </Modal>
</template>

<script>

import Modal from "@dtplugins/modal/modal";
import ProgressBar from "@plugins/progress-bar/progress-bar.vue";
export default {
  components: {
    Modal,
    ProgressBar
  },
  props: {
    fileUploadingFlag :{
      type: Boolean,
      default:false,
    },
    fileUploaderDuration:{
        type:Number,
        default:2400,

    }  ,
    fileUploaderProgress:{
        type:Number,
        default:0,
    }
    
  },
  data: function() {
    return {
    };
  },
  mounted: function() {
   
  },
  watch: {},
  computed: {
  },
  methods: {
    onCancel: function() {
      this.$emit("cancelled", true);
    },
  }
};
</script>

<style lang="scss">

</style>
